import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #868e96;
  margin-bottom: 5px;
`;

export const InputBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  border: 1px #c3d0dd solid;
`;

export const Input = styled.input`
  width: 100%;
  font-family: var(--font-family);
  height: 50px;
  border: none;
  border-radius: 4px;
  padding: 0 10px;
`;
